import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const InputValidIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M22.5 4.67 21.76 4 8.66 18.51l-6.42-7.09-.74.68L8.66 20 22.5 4.67Z" />
  </IconWrapper>
)

export default InputValidIconMedium
